import {
  Dropdown,
  PaginatedDropdownList,
  SequencesStepsListData,
  sequencesStepsListListInfiniteOptions,
  TagsListData,
  tagsListListInfiniteOptions
} from '@crm/api'
import { InfiniteSelect } from '@crm/components'
import { LeadSequenceStatus } from '@crm/types'
import {
  defaultFiltersMultipleValues,
  defaultFiltersNumberValues
} from '@crm/utils'
import { useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { Select } from 'antd'
import { useParams } from 'react-router-dom'

export const CampaignLeadsFilters = () => {
  const { t } = useLocales()
  const { id } = useParams()
  const { params, updateQuery } = useQueryUpdate()

  const tagsValue = defaultFiltersMultipleValues(params?.tags, true)
  const campaignStepValue = defaultFiltersNumberValues(params?.step)

  return (
    <>
      <InfiniteSelect<TagsListData, PaginatedDropdownList, Dropdown>
        mode="multiple"
        value={tagsValue}
        onChange={(tags) => updateQuery({ tags })}
        className="select-min-width"
        placeholder={t('nomenclature.tags')}
        getQueryFunction={tagsListListInfiniteOptions}
        baseOptions={{
          query: {
            preference: tagsValue
          }
        }}
        maxTagCount={1}
        maxTagTextLength={6}
      />

      <InfiniteSelect<SequencesStepsListData, PaginatedDropdownList, Dropdown>
        getQueryFunction={sequencesStepsListListInfiniteOptions}
        placeholder={t('campaigns.steps')}
        onChange={(step) => updateQuery({ step })}
        baseOptions={{
          path: {
            sequence_id: String(id)
          },
          query: {
            preference: campaignStepValue ? [campaignStepValue] : []
          }
        }}
        value={campaignStepValue}
        mode="multiple"
        className="select-min-width"
        maxTagCount={1}
        maxTagTextLength={6}
      />

      <Select
        allowClear
        value={params.status}
        onChange={(status) => updateQuery({ status })}
        placeholder={t('campaigns.status')}
        className="select-min-width"
        options={Object.values(LeadSequenceStatus).map((item) => ({
          label: t(`campaigns.stats_${item}`),
          value: item
        }))}
      />
    </>
  )
}
